import { Loader2 } from 'lucide-react';

import { cn } from '@nesso/ui/lib/utils';

type Props = {
    label: string;
    className?: string;
};

export function CenteredSpinner({ label, className }: Props) {
    return (
        <div
            role="status"
            aria-label={label}
            className={cn('flex flex-1 items-center justify-center', className)}
        >
            <Loader2 className="h-8 w-8 animate-spin" />
        </div>
    );
}
